import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose, withState, withHandlers } from 'recompose'

import { resetPassword } from 'data/auth/actions'
import { selectors as ConfigSelectors } from 'data/config'

import { Input } from 'components/Utils/Form'
import { Button, Text } from 'components/base'
import BackToSignin from './BackToSignin'

class AuthResetPassword extends Component {
  static propTypes = {
    setPassword: PropTypes.func.isRequired,
    resetPassword: PropTypes.func.isRequired,
    resetPasswordToken: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
  }

  onResetPassword = event => {
    event.preventDefault()
    const { resetPassword, password, resetPasswordToken } = this.props
    resetPassword({ password, resetPasswordToken })
  }

  render() {
    const { setPassword, boardingAppRoot } = this.props
    return (
      <div className="height-full flexbox-grow flexbox flexbox-column">
        <div className="margin-bottom-large">
          <BackToSignin />
        </div>
        <form
          className="flexbox flexbox-column"
          onSubmit={this.onResetPassword}
        >
          <Text.Title className="margin-bottom-large center-text">
            Enter a new password
          </Text.Title>
          <Text.Section>
            You need at least 8 characters. Ideally, include letters and
            numbers.
          </Text.Section>
          <Input
            id="password"
            type="password"
            placeholder="your new password"
            className="margin-top-large margin-bottom-normal"
            onChange={setPassword}
            tabIndex="1"
          />
          <Button.Primary tabIndex="2" type="submit">
            Reset my password
          </Button.Primary>
          <Text.Detail className="margin-vertical-normal">
            Please note that for security reasons, this will log you out from
            any existing session you might have.
          </Text.Detail>
        </form>
        <div
          href="/organization/create"
          className="margin-vertical-large font-size-smaller shade-20"
        >
          Not your team?{' '}
          <Text.Action href={`${boardingAppRoot}/organization/select`}>
            Join another team
          </Text.Action>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  boardingAppRoot: ConfigSelectors.getBoardingAppRoot(state),
})

export default compose(
  withState('password', 'setPassword', ''),
  withHandlers({
    setPassword: ({ setPassword }) => event => setPassword(event.target.value),
  }),
  connect(
    mapStateToProps,
    { resetPassword }
  )
)(AuthResetPassword)
